var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-show=\"limit < total\">\n<div ng-click=\"onLoadMore()\" class=\"scroll-watch-list-tail\">\nShowing {{limit}} from {{total}}. Click to load more ..\n</div>\n<div style=\"text-align: center;\">\nThe number of initially visible items can be set on the\n<a href=\"#/personalization\">personalization</a> page.\n</div>\n</div>";
var id1="client/app-service/scroll-watch.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;